import { Controller } from '@hotwired/stimulus';
import { slideToggle } from '../helpers';

export default class extends Controller {
    static get targets () {
        return ['more'];
    }

    connect() {
        const toggles = this.element.querySelectorAll('.accordion-head');
        toggles.forEach(toggle => {
            toggle.addEventListener('click', () => {
                const item = toggle.parentElement;
                slideToggle(item.querySelector('.accordion-body'));
                item.classList.toggle('active');
            });
        });
    }

    moreTargetConnected(element) {
        element.addEventListener('click', () => {
           this.element.classList.remove('accordion--more');
           element.remove();
        });
    }
}